var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.classContenedora,attrs:{"href":_vm.urlWeb,"target":"_blank"}},[_c('img',{style:(_vm.styleImg),attrs:{"id":"logo-institucion","src":_vm.getUrlImagen}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5507022e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","b-carousel-slide":"img-src"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/generales/iconos/LogoInstitucion.vue
// module id = 1jma
// module chunks = 1